var render = function render(){
  var _vm=this;
  var _h=_vm.$createElement;
  var _c=_vm._self._c||_h;

  return _c('div', {
    staticClass: "pointer archive-button button-item-handler white--text no-decoration",
    on: {
      "click": _vm.refreshLimits
    }
  }, [_c('img', {
    staticClass: "nav-link-icon refresh-icon",
    attrs: {
      "src": "https://uploads-ssl.webflow.com/648b04f9d8e52d9524912b4a/648b04f9d8e52d9524912f4b_icons8-available-updates%20(1).svg",
      "alt": ""
    }
  })]);

}
var staticRenderFns = []

export { render, staticRenderFns }